var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.5H10.5C7.4375 14.5 5 16.9688 5 20C5 20.5625 5.4375 21 6 21H18C18.5312 21 19 20.5625 19 20C19 16.9688 16.5312 14.5 13.5 14.5ZM6.5 19.5C6.75 17.5312 8.4375 16 10.5 16H13.5C15.5312 16 17.2188 17.5312 17.4688 19.5H6.5ZM12 13C14.1875 13 16 11.2188 16 9C16 6.8125 14.1875 5 12 5C9.78125 5 8 6.8125 8 9C8 11.2188 9.78125 13 12 13ZM12 6.5C13.375 6.5 14.5 7.625 14.5 9C14.5 10.4062 13.375 11.5 12 11.5C10.5938 11.5 9.5 10.4062 9.5 9C9.5 7.625 10.5938 6.5 12 6.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3768b21395a4431fcd87fc0647915fcd.svg";
export { ForwardRef as ReactComponent };